import { featureEnabled, userFeatureEnabled } from "./helpers";

export interface CustomerFeedbacksMayInterface {
  (session: SessionInterface, path: "customer-feedbacks"): boolean;
  (
    session: SessionInterface,
    path: "customer-feedbacks",
    action: "new" | "import" | "export" | "editTopics" | "classifyDetail",
  ): boolean;

  (
    session: SessionInterface,
    path: "customer-feedbacks",
    action: "show" | "edit" | "markDone" | "delete" | "comment",
    feedbackOrAnnotation: CustomerFeedbackAnnotation | CustomerFeedback,
  ): boolean;

  (
    session: SessionInterface,
    path: "customer-feedbacks",
    action: "allDone" | "classify" | "selfClassify",
    feedback: CustomerFeedback,
  ): boolean;
}

const CustomerFeedbackPermissions: PermissionType<CustomerFeedback | CustomerFeedbackAnnotation> = {
  "customer-feedbacks": {
    index: ({ currentUser, currentProject }) => featureEnabled(currentUser, currentProject, "customer_feedbacks"),
    edit: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      userFeatureEnabled(currentUser, "customer_feedbacks/write"),
    new: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      userFeatureEnabled(currentUser, "customer_feedbacks/write"),
    import: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      userFeatureEnabled(currentUser, "customer_feedbacks/write"),
    export: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      userFeatureEnabled(currentUser, "customer_feedbacks/write"),
    delete: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      userFeatureEnabled(currentUser, "customer_feedbacks/write"),
    allDone: ({ currentUser, currentProject }, resource) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      userFeatureEnabled(currentUser, "customer_feedbacks/write") &&
      !(resource as CustomerFeedback).allDone,
    classify: ({ currentUser, currentProject }, resource) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      userFeatureEnabled(currentUser, "customer_feedbacks/write") &&
      (resource as CustomerFeedback).state === "NONE",
    classifyDetail: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      userFeatureEnabled(currentUser, "customer_feedbacks/write"),
    selfClassify: ({ currentUser, currentProject }, resource) => {
      const grade = (resource as CustomerFeedback<{ grade: number | undefined }>).attrs?.grade;
      if (grade === undefined) {
        return false;
      }

      return (
        featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
        (resource as CustomerFeedback).userId === currentUser.id &&
        (resource as CustomerFeedback).selfAssessmentState === "NONE" &&
        grade <= 4
      );
    },

    markDone: ({ currentUser, currentProject }, resource) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      !(resource as CustomerFeedbackAnnotation).done,
    comment: ({ currentUser, currentProject }, _resource) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks"),
    editTopics: ({ currentUser, currentProject }) =>
      featureEnabled(currentUser, currentProject, "customer_feedbacks") &&
      userFeatureEnabled(currentUser, "customer_feedbacks/write"),
  },
};

export default CustomerFeedbackPermissions;
